var _templateObject = _taggedTemplateLiteralLoose(['\n  ', '\n'], ['\n  ', '\n']),
  _templateObject2 = _taggedTemplateLiteralLoose(['\n  width: 536px;\n  margin: 32px;\n'], ['\n  width: 536px;\n  margin: 32px;\n']),
  _templateObject3 = _taggedTemplateLiteralLoose(['\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n  margin-bottom: 8px;\n'], ['\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n  margin-bottom: 8px;\n']),
  _templateObject4 = _taggedTemplateLiteralLoose(['\n  font-weight: 600;\n  font-size: 20px;\n  line-height: 1.4;\n  color: #4a4a4a;\n'], ['\n  font-weight: 600;\n  font-size: 20px;\n  line-height: 1.4;\n  color: #4a4a4a;\n']),
  _templateObject5 = _taggedTemplateLiteralLoose(['\n  font-size: 16px;\n  line-height: 1.5;\n  font-weight: normal;\n  color: #4a4a4a;\n'], ['\n  font-size: 16px;\n  line-height: 1.5;\n  font-weight: normal;\n  color: #4a4a4a;\n']),
  _templateObject6 = _taggedTemplateLiteralLoose(['\n  font-family: \'Nunito Sans\';\n  height: 116px;\n  resize: none;\n  border: 1px solid #d2d2d2;\n  border-radius: 4px;\n  width: 100%;\n  padding-top: 11px;\n  padding-bottom: 12px;\n  padding-left: 16px;\n  color: #4a4a4a;\n  font-size: 16px;\n  box-sizing: border-box;\n  &::-webkit-input-placeholder {\n    color: #d2d2d2;\n  }\n  &::placeholder {\n    color: #d2d2d2;\n  }\n'], ['\n  font-family: \'Nunito Sans\';\n  height: 116px;\n  resize: none;\n  border: 1px solid #d2d2d2;\n  border-radius: 4px;\n  width: 100%;\n  padding-top: 11px;\n  padding-bottom: 12px;\n  padding-left: 16px;\n  color: #4a4a4a;\n  font-size: 16px;\n  box-sizing: border-box;\n  &::-webkit-input-placeholder {\n    color: #d2d2d2;\n  }\n  &::placeholder {\n    color: #d2d2d2;\n  }\n']),
  _templateObject7 = _taggedTemplateLiteralLoose(['\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n  align-items: center;\n'], ['\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n  align-items: center;\n']),
  _templateObject8 = _taggedTemplateLiteralLoose(['\n  text-decoration: none;\n  line-height: 1.5;\n  font-size: 16px;\n  margin-right: 32px;\n\n  &:hover {\n    text-decoration: underline;\n  }\n'], ['\n  text-decoration: none;\n  line-height: 1.5;\n  font-size: 16px;\n  margin-right: 32px;\n\n  &:hover {\n    text-decoration: underline;\n  }\n']),
  _templateObject9 = _taggedTemplateLiteralLoose(['\n  margin-right: 16px;\n'], ['\n  margin-right: 16px;\n']),
  _templateObject10 = _taggedTemplateLiteralLoose(['\n  max-width: 144px;\n'], ['\n  max-width: 144px;\n']);
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
function _taggedTemplateLiteralLoose(strings, raw) {
  strings.raw = raw;
  return strings;
}

/* eslint-disable no-console */
/* eslint-disable react/jsx-curly-newline */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import styled from 'styled-components';
import { Title, Text, Button, Icon, Link } from '@olxbr/design-system/web';
import PropTypes from 'prop-types';
import Rating from 'react-rating';
import { Step } from '../constants';
import { sendEvent } from '../util/tracking';
var DivCustom = styled.div(_templateObject, function (_ref) {
  var mb = _ref.mb,
    color = _ref.color;
  var style = '';
  if (mb) {
    style += 'margin-bottom: ' + mb + 'px;';
  }
  if (color) {
    style += 'color: ' + color + ';';
  }
  return style;
});
var ContainerDiv = styled.div(_templateObject2);
var CloseModal = styled.div(_templateObject3);
var TitleCustom = styled(Title)(_templateObject4);
var TextDiv = styled(Text)(_templateObject5);

// const InputCustom = styled(Input)`
//   height: 116px;
//   resize: none;
// `

var InputCustom = styled.textarea(_templateObject6);
var ButtonDiv = styled.div(_templateObject7);
var LinkCustom = styled(Link)(_templateObject8);
var StarIconCustom = styled(Icon)(_templateObject9);
var StarIcon = function StarIcon(_ref2) {
  var color = _ref2.color;
  return React.createElement(StarIconCustom, {
    svgPath: 'M8.412 7.575l2.915-5.907a.75.75 0 0 1 1.346 0l2.915 5.907 6.52.953a.75.75 0 0 1 .415 1.28l-4.717 4.594 1.113 6.491a.75.75 0 0 1-1.088.79L12 18.618l-5.83 3.067a.75.75 0 0 1-1.09-.79l1.114-6.492-4.717-4.595a.75.75 0 0 1 .415-1.28l6.52-.952zM12 3.695L9.583 8.591a.75.75 0 0 1-.565.41l-5.407.79 3.912 3.81a.75.75 0 0 1 .216.665l-.923 5.382 4.835-2.543a.75.75 0 0 1 .698 0l4.835 2.543-.923-5.382a.75.75 0 0 1 .216-.664l3.912-3.81-5.407-.79a.75.75 0 0 1-.565-.411L12 3.694z',
    width: 32,
    height: 32,
    color: color
  });
};
var ButtonWithoutFlex = styled(Button)(_templateObject10);
var Survey = function (_React$Component) {
  _inherits(Survey, _React$Component);
  function Survey() {
    var _temp, _this, _ret;
    _classCallCheck(this, Survey);
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.surveySent = function (nextStep) {
      console.log('Enviar avaliação!', _this.props);

      // Se tudo der certo no envio da avaliação
      _this.props.nextStep(nextStep);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }
  Survey.prototype.componentDidMount = function componentDidMount() {
    sendEvent({
      event_type: 'page_view',
      object_detail: 'step_survey',
      object_name: 'ad_deleting_survey'
    });
  };
  Survey.prototype.render = function render() {
    var _this2 = this;
    return React.createElement(ContainerDiv, null, React.createElement(CloseModal, null, React.createElement(Link, {
      href: '',
      onClick: function onClick(e) {
        e.preventDefault();
        _this2.props.closeModal('ad_deleting_survey');
      }
    }, React.createElement(Icon, {
      svgPath: 'M13.0606602,12 L18.5303301,17.4696699 C18.8232233,17.7625631 18.8232233,18.2374369 18.5303301,18.5303301 C18.2374369,18.8232233 17.7625631,18.8232233 17.4696699,18.5303301 L12,13.0606602 L6.53033009,18.5303301 C6.23743687,18.8232233 5.76256313,18.8232233 5.46966991,18.5303301 C5.1767767,18.2374369 5.1767767,17.7625631 5.46966991,17.4696699 L10.9393398,12 L5.46966991,6.53033009 C5.1767767,6.23743687 5.1767767,5.76256313 5.46966991,5.46966991 C5.76256313,5.1767767 6.23743687,5.1767767 6.53033009,5.46966991 L12,10.9393398 L17.4696699,5.46966991 C17.7625631,5.1767767 18.2374369,5.1767767 18.5303301,5.46966991 C18.8232233,5.76256313 18.8232233,6.23743687 18.5303301,6.53033009 L13.0606602,12 Z',
      width: 24,
      height: 24
    }))), React.createElement(DivCustom, {
      mb: 16
    }, React.createElement(TitleCustom, null, 'Como foi sua experi\xEAncia na OLX?')), React.createElement(DivCustom, {
      mb: 32
    }, React.createElement(TextDiv, {
      tag: 'span'
    }, 'Responda a avalia\xE7\xE3o e ajude a OLX a melhorar cada vez mais :)')), React.createElement(DivCustom, {
      mb: 28
    }, React.createElement(Rating, {
      emptySymbol: React.createElement(StarIcon, {
        color: '#999999'
      }),
      fullSymbol: React.createElement(StarIcon, {
        color: '#fbb000'
      }),
      onChange: function onChange(rate) {
        return _this2.props.handleChange({
          target: {
            name: 'rating',
            value: rate
          }
        });
      },
      initialRating: parseInt(this.props.values.rating, 10),
      start: 0
    })), React.createElement(DivCustom, {
      mb: 32
    }, React.createElement(InputCustom, {
      placeholder: 'Elogios? Cr\xEDticas? Como podemos melhorar?',
      onChange: this.props.handleChange,
      name: 'message',
      value: this.props.values.message
    })), React.createElement(ButtonDiv, null, React.createElement(LinkCustom, {
      type: 'primary',
      onClick: function onClick() {
        sendEvent({
          event_type: 'click',
          object_detail: 'not_evaluate_button',
          object_name: 'ad_deleting_survey'
        });
        _this2.props.closeModal();
      }
    }, 'Agora n\xE3o'), React.createElement(ButtonWithoutFlex, {
      size: 'medium',
      fluid: true,
      disabled: !(this.props.values.rating || this.props.values.message),
      onClick: function onClick() {
        sendEvent({
          event_type: 'click',
          object_detail: 'evaluate_button',
          object_name: 'ad_deleting_survey'
        });
        _this2.surveySent(Step.SURVEY_SENT);
      }
    }, 'Avaliar')));
  };
  return Survey;
}(React.Component);
Survey.propTypes = process.env.NODE_ENV !== "production" ? {
  closeModal: PropTypes.func,
  nextStep: PropTypes.func,
  handleChange: PropTypes.func,
  values: PropTypes.object
} : {};
StarIcon.propTypes = process.env.NODE_ENV !== "production" ? {
  color: PropTypes.string
} : {};
export default Survey;